import { render, staticRenderFns } from "./freight.vue?vue&type=template&id=0845ed98&scoped=true"
import script from "./freight.vue?vue&type=script&lang=js"
export * from "./freight.vue?vue&type=script&lang=js"
import style0 from "./freight.vue?vue&type=style&index=0&id=0845ed98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0845ed98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0845ed98')) {
      api.createRecord('0845ed98', component.options)
    } else {
      api.reload('0845ed98', component.options)
    }
    module.hot.accept("./freight.vue?vue&type=template&id=0845ed98&scoped=true", function () {
      api.rerender('0845ed98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/components/freight.vue"
export default component.exports